import axios from "axios";
import { apiUrl } from "../../config";

export const postQuotation = (orderDetails) => {
    return axios.post(apiUrl + '/orders/quotation', {
        orderDetails: orderDetails
    });
};